import type { TableColumnBase } from '../TableColumnBase';

export type TableColumnFormatFrontendOnly = {
  type: 'frontendOnly';
  /**
   * Untyped here to avoid importing React into utils package
   *
   * @see FrontendOnlyColumnRenderFunction type in frontend package
   */
  render: unknown;
  className?: string;
  alignment?: 'left' | 'right';
};

/**
 * Column with custom render function used only on frontend (action buttons etc.)
 *
 * The type is on purpose in utils, because it turned out one TableColumn
 * and TableColumnFormat enum of all possible types is the best useful,
 * we keep control that every column type is handled properly.
 *
 * Having extended type FrontendTableColumn/FrontendTableEndpoint turned
 * out to be clumsy and making impossible to write common endpoint/columns functions
 * to utils, and with doubtful benefits.
 *
 * createFrontendOnlyColumn is on purpose kept in frontend package
 * to properly cover `FrontendOnlyColumnFormat.render` type which refers
 * to many frontend-specific types.
 */
export type FrontendOnlyColumn<TRow> = TableColumnBase<
  TRow,
  TableColumnFormatFrontendOnly
>;
